export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq5-PDFReport-CISO.25941acc.jpg";